import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { PercorsoRegolamentatoView } from 'src/app/model/percorso-regolamentato-view';
import { AttachmentsService } from 'src/app/services/attachments/attachments.service';
import { MatDialog, MAT_DIALOG_DATA, MatDialogRef, MatDialogModule } from '@angular/material/dialog';
import { CorsiComponent } from '../corsi/corsi.component';

@Component({
  selector: 'app-percorsi',
  templateUrl: './percorsi.component.html',
  styleUrls: ['./percorsi.component.scss']
})
export class PercorsiComponent implements OnInit, AfterViewInit {
  constructor(private attachmentsService: AttachmentsService, public dialog: MatDialog) {
    this.dataSource = new MatTableDataSource();
   }
  dataSource: MatTableDataSource<PercorsoRegolamentatoView>;
  displayedColumns: string[] = [
    "descrizione",
    "azioni",
  ];
  totalItems: number = 0;
  pageSize: number = 10; // Imposta la dimensione della pagina iniziale
  pageSizeOptions: number[] = [5, 10, 25, 100]; // Opzioni di dimensione pagina
  pageIndex = 0;

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  currentPage: number;

  public ngAfterViewInit(): void {
    this.currentPage = 0;
    this.pageSize = 10;
  }

  public onPageChange(event: PageEvent) {
    this.currentPage = event.pageIndex;
    this.loadDatatable();
  }

  ngOnInit(): void {
    this.loadDatatable();
  }

  loadDatatable() {
    this.attachmentsService.ricercaPercorsiRegolamentati(this.pageIndex, this.pageSize).subscribe({
      next: (response: any) => {
        this.totalItems = response.result.count;
        // for (let i = 0; i < this.totalItems - 1; i++) {
        //   let strCamelCase = response.result.listaPercorsoRegolamentato[i].descrizione.charAt(0).toUpperCase() + response.result.listaPercorsoRegolamentato[i].descrizione.substr(1).toLowerCase();
        //   response.result.listaPercorsoRegolamentato[i].descrizione = strCamelCase;
        // }
        // this.dataSource = new MatTableDataSource<PercorsoRegolamentatoView>(response.result.listaPercorsoRegolamentato);
        this.dataSource = new MatTableDataSource(response.result.listaPercorsoRegolamentato);
        this.dataSource.sort = this.sort;
      }
    })
  }

  downloadPercorso(id:any) {
    let data = {
      valore:id
    }
    this.attachmentsService.downloadDocumentoHomePage(data).subscribe(
      (data:any) => {
        let fileName: string = "Decreto.pdf";
        this.attachmentsService.downloadService(data, fileName);
      }
    )
  }

  elencoCorsi(el : any) {
    const dialogRef = this.dialog.open(CorsiComponent, {
      data: { title: "Elenco Corsi", idPercorso: el.id, tipoPercorso: 2 },
      height: 'auto',
      width: '100%'
    });

    dialogRef.afterClosed().subscribe((result: any) => {
    })
  }

  onPaginateChange(event: any) {
    this.pageIndex = event.pageIndex;
    this.pageSize = event.pageSize;

    this.loadDatatable();
  }

}
